import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { enableMapSet } from "immer";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import accounts from "./core/accounts";
import alerts from "@src/alerts/alertsSlice";
import appData from "./appdata";
import bookmarks from "./core/bookmarks";
import buildingReporting from "@src/reports/building/buildingReportingSlice";
import buildings from "./core/buildings";
import buildingLayout from "@src/buildingLayout/buildingLayoutSlice";
import contacts from "./core/contacts";
import curtailment from "../curtailment/curtailmentSlice";
import curtailmentExp from "../curtailment/curtailmentExpSlice";
import curtailmentContacts from "../curtailment/contacts/contactSlice";
import curtailmentNotifications from "../curtailment/notifications/notificationSlice";
import curtailmentPrograms from "../curtailment/programs/programSlice";
import curtailmentResources from "../curtailment/resources/resourceSlice";
import dailyMetrics from "./core/dailyMetrics";
import datapoints from "@store/core/datapoints";
import energyData from "@src/energyData/energyDataSlice";
import energystar from "@energystar/esSlice";
import energystarRatings from "@energystar/energystarRatings";
import enrollments from "@src/curtailment/enrollments_deprecated/enrollmentSlice";
import equipment from "./core/equipment";
import extras, { handleExtras } from "./core/extras";
import iaq from "@src/iaq/iaqSlice";
import iaqIndex from "@src/iaqIndex/iaqIndexSlice";
import iaqTrends from "@src/iaqTrends/iaqTrendsSlice";
import jobs from "@src/jobs/jobsSlice";
import layout from "./layout";
import modeling from "../modeling/modelingSlice";
import navbar from "./navbar";
import organizations from "./core/organizations";
import peakAdvisor from "@experiences/dashboard/peakAdvisor/peakAdvisorSlice";
import persistedAppData from "./persistedappdata";
import portfolioReporting from "@src/reports/portfolio/portfolioReportingSlice.js";
import portfolios from "@src/portfolios/portfoliosSlice";
import reportData from "./reporting";
import sandbox from "../sandbox/sandboxSlice";
import settings from "../views/settingsSlice.js";
import steamTraps from "@src/steamtraps/steamTrapsSlice";
import spacesReport from "@src/spacesReport/spacesReportSlice";
import teams from "@teams/teamSlice";
import tenantBilling from "../tenantBilling/tenantBillingSlice.js";
import urjanet from "@urjanet/urjanetSlice";
import wellstatFuture from "@src/wellstatFuture/wellstatFutureSlice";
import complianceVault from "../complianceVault/complianceVaultSlice";
import baselineAudit from "../baselineAudit/baselineAuditSlice";
import { setExtrasHandler } from "@store/extrasHelper";

enableMapSet();

const reducers = combineReducers({
  accounts,
  alerts,
  appData,
  bookmarks,
  buildingReporting,
  buildings,
  contacts,
  buildingLayout,
  curtailment,
  curtailmentExp,
  curtailmentContacts,
  curtailmentNotifications,
  curtailmentPrograms,
  curtailmentResources,
  dailyMetrics,
  datapoints,
  energyData,
  energystar,
  energystarRatings,
  enrollments,
  equipment,
  extras,
  iaq,
  iaqIndex,
  iaqTrends,
  jobs,
  layout,
  modeling,
  navbar,
  organizations,
  peakAdvisor,
  persistedAppData,
  portfolioReporting,
  portfolios,
  reportData,
  sandbox,
  settings,
  steamTraps,
  spacesReport,
  teams,
  tenantBilling,
  urjanet,
  wellstatFuture,
  complianceVault,
  baselineAudit,
});

const persistConfig = {
  key: "layout",
  storage,
  whitelist: ["layout", "bookmarks", "persistedAppData"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

setExtrasHandler((payload: any) => {
  store.dispatch(handleExtras(payload));
});

export type RootState = ReturnType<typeof store.getState>;
